var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-header",class:_vm.color},[_c('span',{staticClass:"section-title"},[_c('img',{staticClass:"icon",attrs:{"src":require("../../../assets/icons/lock-outline.svg")}}),_vm._v("\n    "+_vm._s(_vm.titleText)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"section-seperator"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf9163aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base-components/credentials/credentials-list/CredentialsSettingsSectionHeader.vue
// module id = null
// module chunks = 